// extracted by mini-css-extract-plugin
module.exports = {"page-header":"invoices_page-header__W3NjR"};